// queries
import Containers from './resolvers/Containers';
import deleteUserAvatar from './resolvers/deleteUserAvatar';
import disconnectTeamInSlack from './resolvers/disconnectTeamInSlack';
import MyAvatar from './resolvers/MyAvatar';
import TeamInSlack from './resolvers/TeamInSlack';
import TeamLinkIcons from './resolvers/TeamLinkIcons';
import updateTeamInSlack from './resolvers/updateTeamInSlack';
import updateUser from './resolvers/updateUser';
import updateUserAvatar from './resolvers/updateUserAvatar';
import updateUserPrivacySettings from './resolvers/updateUserPrivacySettings';
import User from './resolvers/User';
import UserManageConfig from './resolvers/UserManageConfig';
import UserManageLinkedAccounts from './resolvers/UserManageLinkedAccounts';
import UserManagePrivacySettings from './resolvers/UserManagePrivacySettings';
import UserManagePrivacySettingsAllowed from './resolvers/UserManagePrivacySettingsAllowed';
import UserOrganization from './resolvers/UserOrganization';

// mutations

var resolvers = {
  Query: {
    User: User,
    MyAvatar: MyAvatar,
    UserOrganization: UserOrganization,
    UserManageConfig: UserManageConfig,
    UserManagePrivacySettings: UserManagePrivacySettings,
    UserManageLinkedAccounts: UserManageLinkedAccounts,
    UserManagePrivacySettingsAllowed: UserManagePrivacySettingsAllowed,
    TeamInSlack: TeamInSlack,
    Containers: Containers,
    TeamLinkIcons: TeamLinkIcons
  },
  Mutation: {
    updateUser: updateUser,
    deleteUserAvatar: deleteUserAvatar,
    updateUserAvatar: updateUserAvatar,
    updateUserPrivacySettings: updateUserPrivacySettings,
    updateTeamInSlack: updateTeamInSlack,
    disconnectTeamInSlack: disconnectTeamInSlack
  }
};
export default resolvers;